/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowOutdoorFamilyDayTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowOutdoorFamilyDay,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Enjoy a Day Outdoors with Family!",
    "Outdoor Family Day Awaits!",
    "Fun and Sun with the Family!",
  ],
  title: "Outdoor Family Day",
  description: "Organize a fun outdoor family day.",
  longDescription:
    "Gather your family for an exciting outdoor day! Choose a date, decide on activities, and plan refreshments!",
  emoji: "🌞",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Outdoor Family Day",
          emoji: "🌞",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we hold the outdoor family day?",
          emoji: "📅",
          completeAction: {
            question: "Decide on activities to do?",
            description: "What activities should we focus on during the day?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What activities should we consider?",
                emoji: "⚽",
                completeAction: {
                  question: "Decide on refreshments?",
                  description:
                    "What refreshments should we prepare for the day?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What refreshments should we bring?",
                      emoji: "🍉",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Enjoy the Outdoors Together!",
    outroDescription:
      "Your outdoor family day plans are set! Enjoy the fun in the sun!",
  },
};
